import { useContext, useEffect, useState } from "react";

import { APIEndpoints } from "src/types/apiTypes";
import useFetch from "../useFetch";

import { addPatientDetails, resetPatientDetails } from "src/helpers/addCase";
import { LoaderContext } from "src/context/loaderContext";
import { UseFormGetValues, UseFormSetValue, UseFormTrigger } from "react-hook-form";
import { AddCaseProps } from "src/pages/addCase/types";
import { PatientDetailType } from "src/components/caseStepTwo/types";



const usePatientDetailFunc = (
  globalPatientId: number, setValue: UseFormSetValue<AddCaseProps>,
  trigger: UseFormTrigger<AddCaseProps>, getValues: UseFormGetValues<AddCaseProps>,
): void => {
  const [prevPatientId, setPrevPatientId] = useState<number>(getValues("patient_attributes.global_patient_id"))

  const { setLoader, hideLoader } = useContext(LoaderContext)

  /**
   * @PatientDetailsById
   */
  const { data: patientDetailApiResponse, error: patientDetailApiError, mutate: getPatientById, removeErrorAndData: clearPatientDetails } =
    useFetch<PatientDetailType>(APIEndpoints.GET_PATIENT_DETAILS_BY_ID, {}, {}, false);

  useEffect(() => {
    if (typeof globalPatientId === "number" && prevPatientId !== globalPatientId) {
      resetPatientDetails(setValue, globalPatientId);
      setPrevPatientId(0);

      if (globalPatientId !== 0) {
        setLoader();
        clearPatientDetails();
        getPatientById(null, null, { global_patient_id: globalPatientId });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalPatientId]);

  useEffect(() => {
    if (patientDetailApiResponse || patientDetailApiError) {
      hideLoader();
      if (patientDetailApiResponse) {
        setPrevPatientId(patientDetailApiResponse.data.patient_info.id);
        addPatientDetails(setValue, patientDetailApiResponse);
        trigger(["patient_attributes", "insurances_attributes"]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientDetailApiResponse, patientDetailApiError]);
}

export default usePatientDetailFunc
